<form [formGroup]="skjema" (ngSubmit)="lagre()" novalidate>
    <h2 class="overskrift">
        @if (spoerreskjema()) {
            {{ 'Rediger spørreskjema' | translate }}
        } @else {
            {{ 'Nytt spørreskjema' | translate }}
        }
    </h2>

    @if (erLaast()) {
        <inline-melding type="advarsel" data-testid="laast-melding">
            {{ 'Skjemaet er i bruk i {antall} undersøkelser. Du kan endre tekster og farger, men ikke legge til, fjerne eller flytte spørsmål, eller endre type og svaralternativer. Lag en kopi av skjemaet for å gjøre slike endringer.' | translate: {antall: spoerreskjema()!.antallUndersoekelser} }}
        </inline-melding>
    }

    <mat-form-field class="full-bredde">
        <mat-label>{{ 'Tittel' | translate }}</mat-label>
        <input matInput [formControl]="skjema.controls.tittel" data-testid="skjema-tittel-felt">
        @if (skjema.controls.tittel.hasError('required')) {
            <mat-error>{{ 'Tittel må fylles ut' | translate }}</mat-error>
        }
        @if (skjema.controls.tittel.hasError('maxlength')) {
            <mat-error>{{ 'Tittelen er for lang' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="full-bredde">
        <mat-label>{{ 'Beskrivelse' | translate }}</mat-label>
        <riktekst-redigering [skjemakontroll]="skjema.controls.beskrivelse"/>
    </mat-form-field>

    <mat-form-field class="full-bredde">
        <mat-label>{{ 'Ekstra instruksjoner ved KI-analyse' | translate }}</mat-label>
        <textarea matInput rows="4" [formControl]="skjema.controls.ekstraAnalyseprompt" data-testid="ekstra-analyseprompt-felt"></textarea>
        <mat-hint>{{ 'Legges til promptet når det genereres analyse av resultatet til undersøkelser som bruker skjemaet' | translate }}</mat-hint>
    </mat-form-field>

    <h3 class="overskrift">{{ 'Tilgang' | translate }}</h3>

    <mat-radio-group class="tilgang" [formControl]="skjema.controls.tilgang" data-testid="tilgang-felt">
        <mat-radio-button value="alle" data-testid="tilgang-alle">{{ 'Tilgjengelig for alle' | translate }}</mat-radio-button>
        <mat-radio-button value="utvalgteAvtaler" data-testid="tilgang-utvalgte-avtaler">{{ 'Kun for grupper i utvalgte avtaler' | translate }}</mat-radio-button>
    </mat-radio-group>

    @if (skjema.controls.tilgang.value === 'utvalgteAvtaler') {
        <velg-avtaler [skjemakontroll]="skjema.controls.avtaler"/>
        @if (skjema.hasError('manglerAvtaler')) {
            <inline-melding type="feil" data-testid="mangler-avtaler">{{ 'Velg minst én avtale' | translate }}</inline-melding>
        }
    }

    <h3 class="overskrift">{{ 'Spørsmål' | translate }}</h3>

    <div cdkDropList [cdkDropListDisabled]="erLaast()" (cdkDropListDropped)="spoersmaalFlyttet($event)" class="spoersmaalsliste">
        @for (spoersmaal of skjema.controls.spoersmaal.controls; track spoersmaal; let indeks = $index) {
            <div class="spoersmaal-rad" cdkDrag data-testid="spoersmaal-rad">
                @if (!erLaast()) {
                    <div cdkDragHandle class="sortering-handler">
                        <mat-icon fontSet="ion-navicon" class="mat-icon--ionic-ikon" data-testid="dra-og-slipp"/>
                    </div>
                }
                <spoerreskjema-spoersmaal-rediger class="spoersmaal" [skjema]="spoersmaal" [erLaast]="erLaast()"
                                                  [alternativkandidater]="alternativkandidater().get(spoersmaal) ?? ingenKandidater"
                                                  [avvikendeKorrelerte]="avvikendeKorrelerte().get(spoersmaal) ?? ingenKorrelerte"
                                                  (slett)="slettSpoersmaal(indeks)"/>
            </div>
        }
    </div>

    @if (skjema.controls.spoersmaal.hasError('manglerSpoersmaal')) {
        <inline-melding type="feil">{{ 'Skjemaet må ha minst ett spørsmål' | translate }}</inline-melding>
    }
    @if (skjema.controls.spoersmaal.hasError('foersteIkkeGruppe')) {
        <inline-melding type="feil">{{ 'Første spørsmål i skjemaet må være en gruppe' | translate }}</inline-melding>
    }
    @if (skjema.controls.spoersmaal.hasError('gruppeUtenSpoersmaal')) {
        <inline-melding type="feil">{{ 'Alle grupper må ha minst ett spørsmål' | translate }}</inline-melding>
    }

    @if (!erLaast()) {
        <div class="legg-til">
            <button mat-stroked-button type="button" (click)="leggTilGruppe()" data-testid="legg-til-gruppe-knapp">{{ '+ Legg til gruppe' | translate }}</button>
            <button mat-stroked-button type="button" (click)="leggTilSpoersmaal()" data-testid="legg-til-spoersmaal-knapp">{{ '+ Legg til spørsmål' | translate }}</button>
        </div>
    }

    @if (antallBrutteKorrelasjoner() > 0) {
        <inline-melding type="advarsel" data-testid="brutte-korrelasjoner">
            {{ 'For {antall} spørsmål vil resultatene ikke lenger sammenliknes med tilsvarende spørsmål i andre skjemaer, se meldingene ved spørsmålene.' | translate: {antall: antallBrutteKorrelasjoner()} }}
        </inline-melding>
    }

    @if (feilmelding()) {
        <inline-melding type="feil" data-testid="feilmelding">{{ feilmelding() }}</inline-melding>
    }

    <kort-handlinger>
        <button mat-button type="button" (click)="avbryt()" data-testid="avbryt-knapp">{{ 'Avbryt' | translate }}</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="lagrer() || skjema.invalid" data-testid="lagre-knapp">
            {{ 'Lagre' | translate }}
        </button>
    </kort-handlinger>
</form>
